import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthProvider, RequireAuth } from "@ui/components/AuthProvider";
import SnackbarComponent from "@ui/components/SnackbarComponent";
import { SnackbarProvider } from "notistack";
import React, { useEffect, useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { createGlobalStyle } from "styled-components";

import OTP from "./@ui/Auth/OTP";
import ResetPassword from "./@ui/Auth/ResetPassword";
import SendOTP from "./@ui/Auth/SendOTP";
import Signin from "./@ui/Auth/Signin";
import SignUp from "./@ui/Auth/SignUp";
import HomePage from "./pages/HomePage/HomePage";
// import { RequireAuth } from "@ui/components/AuthProvider";
import LandingPage from "./@ui/components/LandingPage/LandingPage";
import Loader from "./components/Loader";
import ResponsiveDrawer from "@ui/MuiComponents/Drawer/ResponsiveDrawer";
import commonConfig from "config/commonConfig";
import { primaryMenuRoutes, secondaryMenuRoutes } from "routes";
import enums from "helpers/enums";
import DivisionControl from "@ui/components/LandingPage/DivisionControl";

const theme = createTheme({
  typography: {
    fontFamily: "Advent Pro",
  },
  direction: "ltr",
});

const GlobalStyle = createGlobalStyle`
   body {
    background: #F5F5F5;
  font-family: 'Advent Pro', sans-serif; 
  min-height: 100vh;
  padding-inline: 2vh;overflow:hidden;
  }
 
`;

function App() {
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    const oneauthlogin = window.localStorage.getItem("oneauthlogin");
    if (oneauthlogin !== "true") {
      window.localStorage.setItem("oneauthlogin", true);
    }
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <SnackbarComponent />
          <GlobalStyle />
          <Loader />

          <HashRouter>
            <DivisionControl userInfo={userInfo} />
            <ResponsiveDrawer
              appName={"Cortex"}
              primaryMenus={primaryMenuRoutes}
              userInfo={userInfo}
            >
              <Routes>
                <Route
                  path="*"
                  element={
                    <LandingPage
                      userInfo={userInfo}
                      homePath={enums.models.import}
                    />
                  }
                />
                <Route
                  path="*/:home"
                  element={
                    <LandingPage
                      userInfo={userInfo}
                      homePath={enums.models.import}
                    />
                  }
                />
                <Route
                  path="signIn"
                  element={
                    <Signin
                      title="Cortex Admin Panel"
                      message="Scan and Identify"
                      selfLogin={true}
                      clientSelect=""
                      userInfo={userInfo}
                      setUserInfo={setUserInfo}
                      // additionalHeaders={{ oneauthlogin: true }}
                    />
                  }
                  exact
                />
                {/* <Route path="signUp" element={<SignUp />} exact /> */}
                <Route path="otp" element={<OTP />} exact />
                <Route path="sendOtp" element={<SendOTP />} exact />
                <Route path="resetPassword" element={<ResetPassword />} exact />

                {[...primaryMenuRoutes, ...secondaryMenuRoutes].map(
                  (route, i) => {
                    return (
                      <Route
                        key={i}
                        path={route.path}
                        element={<RequireAuth>{route.component()}</RequireAuth>}
                        exact
                      />
                    );
                  }
                )}
              </Routes>
            </ResponsiveDrawer>
          </HashRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
